import React from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import {
  computeAssemblyComparison,
  parseValueByUnit,
  formatValueByUnit
} from '../tsrComparisonUtils';

const AssemblyComparisonSection = ({ timeSinceRecords, parentAssembly }) => {
  const assemblyRecords = parentAssembly?.timeSinceRecords || [];

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">As compared to Assembly</Typography>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell sx={{ minWidth: 200 }}>Label</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell>Installed At Assembly Value</TableCell>
              <TableCell>Due At Assembly Value</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {timeSinceRecords && timeSinceRecords.length > 0 ? (
              timeSinceRecords.map((record, index) => {
                const comparison = computeAssemblyComparison(record, assemblyRecords);

                const unit =
                  record.elapsedTime?.unit ||
                  record.limit?.unit ||
                  record.remainingTime?.unit ||
                  '';

                const parentSnapshotStr = record.parentAssemblyValueAtInstallation?.value;
                const remainingStr = record.remainingTime?.value;

                let installedDisplay = null;
                let dueDisplay = null;

                if (
                  parentSnapshotStr != null &&
                  String(parentSnapshotStr).trim() !== '' &&
                  remainingStr != null &&
                  String(remainingStr).trim() !== '' &&
                  unit
                ) {
                  try {
                    const installedNumeric = parseValueByUnit(parentSnapshotStr, unit);
                    const remainingNumeric = parseValueByUnit(remainingStr, unit);
                    const dueNumeric = installedNumeric + remainingNumeric;

                    installedDisplay = formatValueByUnit(installedNumeric, unit);
                    dueDisplay = formatValueByUnit(dueNumeric, unit);
                  } catch (e) {
                    installedDisplay = null;
                    dueDisplay = null;
                  }
                }

                if (installedDisplay == null) {
                  installedDisplay =
                    comparison.installedAtAssembly != null && comparison.installedAtAssembly !== ''
                      ? comparison.installedAtAssembly
                      : null;
                }

                if (dueDisplay == null) {
                  dueDisplay =
                    comparison.dueAtAssembly != null && comparison.dueAtAssembly !== ''
                      ? comparison.dueAtAssembly
                      : null;
                }

                return (
                  <TableRow key={index}>
                    <TableCell>{record.type}</TableCell>
                    <TableCell>{record.label}</TableCell>
                    <TableCell>{record.elapsedTime?.unit || record.limit?.unit || record.remainingTime?.unit || ''}</TableCell>
                    <TableCell>
                      {installedDisplay != null && installedDisplay !== '' ? installedDisplay : 'N/A'}
                    </TableCell>
                    <TableCell>
                      {dueDisplay != null && dueDisplay !== '' ? dueDisplay : 'N/A'}
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                      {comparison.message || ''}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Add Time Since Records to see assembly comparisons here.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default AssemblyComparisonSection;

